var map = {
	"./ch-de.json": [
		71074,
		604
	],
	"./de.json": [
		95894,
		706
	],
	"./en-CA.json": [
		78701,
		735
	],
	"./en-GB.json": [
		63708,
		86
	],
	"./en-IE.json": [
		79451,
		569
	],
	"./en-US.json": [
		25381,
		963
	],
	"./es.json": [
		46725,
		69
	],
	"./fr.json": [
		94605,
		261
	],
	"./hr.json": [
		36759,
		47
	],
	"./it.json": [
		83672,
		996
	],
	"./pl.json": [
		11029,
		713
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 79842;
module.exports = webpackAsyncContext;